<h1 mat-dialog-title>
    <span *ngIf="!data?.id">{{
        "ods-waypoints.dialog.create" | translate
    }}</span>
    <span *ngIf="data?.id">{{
        "ods-waypoints.dialog.edit" | translate
    }}</span>
</h1>